module.exports = __webpack_public_path__ + "img/sale.93a9b28b.svg";